import { FiUpload } from 'react-icons/fi'

import { AxiosError } from 'axios'
import { t } from 'i18next'

import HeaderPages from '~/components/HeaderPages'
import ListPagination from '~/components/ListPagination'
import Loading from '~/components/Loading'
import Table from '~/components/Table'
import { formatDateToString } from '~/helpers/date'
import { useAlert } from '~/hooks/useAlert'
import { Footer } from '~/pages/products/list/styles'

import { schema } from './schema'

import * as S from './styles'

type UploadItem = {
  id: number
  user_id: string
  publisher_id: string
  file_name: string
  file_path: string
  channel: string
  placement_name: string
  status: string
  status_detail: string | null
  finished_at: string | null
  created_at: string
  updated_at: string
  user_email: string
  user_name: string
}

type QueryData = {
  data: UploadItem[]
  total: number
}

type UploadsTableProps = {
  newButton: React.ReactNode
  data?: QueryData
  error: Error | null
  loading: boolean
  page: number
  quantity: number
  onPagination: (value: number) => void
  onItemsPerPageChange: (value: { value: number }) => void
}

const UploadsTable = ({
  newButton,
  data,
  error,
  loading,
  page,
  quantity,
  onPagination,
  onItemsPerPageChange
}: UploadsTableProps) => {
  const [AlertOnError] = useAlert(
    error &&
      ((error as AxiosError<{ messages?: string[] }>)?.response?.data
        ?.messages?.[0] ||
        t('common:messages.errorOccurred.message'))
  )

  const formattedData =
    data?.data?.map((item: UploadItem) => ({
      ...item,
      formattedUploadDate: formatDateToString(
        item.created_at,
        'DD/MM/YYYY [às] HH:mm'
      ),
      fileName: item.file_name
    })) || []

  return (
    <>
      <HeaderPages
        className="mb-4"
        title={t('rm:ExternalCampaignMetrics.pageTitle')}
        sideRightComponent={
          formattedData.length > 0 || !!error ? newButton : undefined
        }
      />
      <Loading status={loading}>{t('rm:Loading')}</Loading>

      <AlertOnError />

      {!error && data?.total === 0 && !loading && (
        <S.EmptyContainer>
          <S.IconWrapper>
            <FiUpload size={64} />
          </S.IconWrapper>
          <S.EmptyTitle>
            {t('rm:externalCampaignMetrics.list.title')}
          </S.EmptyTitle>
          <S.EmptySubtitle>
            {t('rm:externalCampaignMetrics.list.empty')}
          </S.EmptySubtitle>
          <div className="mt-4">{newButton}</div>
        </S.EmptyContainer>
      )}

      {!error && data?.total > 0 && (
        <>
          <div>
            {!!formattedData && (
              <Table
                schema={schema()}
                data={formattedData}
                smallerRowPadding
                sideBorder
                isLoading={loading}
              />
            )}
          </div>

          <Footer>
            <ListPagination
              total={data?.total || 0}
              label={t('rm:externalCampaignMetrics.list.title')}
              currentPage={page}
              itemsPerPage={quantity}
              menuPlacement="top"
              onClickPagination={onPagination}
              onItemsPerPageChange={onItemsPerPageChange}
            />
          </Footer>
        </>
      )}
    </>
  )
}

export default UploadsTable
